"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconVisibility = function SvgIconVisibility(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "visibility icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Visibility Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.854 23.873a10.485 10.485 0 00-2.452 8.694.374.374 0 01-.37.433H13.5a1.5 1.5 0 110-3h3.75a.75.75 0 00.75-.75v-.75a.75.75 0 00-.75-.75H9a3 3 0 01-3-3V9a3 3 0 013-3h21a3 3 0 013 3v11.033a.375.375 0 01-.438.369 10.48 10.48 0 00-1.768-.15c-.134 0-.266.004-.398.012a.375.375 0 01-.396-.375V9.75a.75.75 0 00-.75-.75H9.75a.75.75 0 00-.75.75V22.5a.75.75 0 00.75.752h12.822a.375.375 0 01.282.62zm2.047 1.036A8.31 8.31 0 0137.787 35.25a.375.375 0 00.01.417l.04.05 3.724 3.724a1.5 1.5 0 01.083 2.03l-.083.091a1.498 1.498 0 01-2.03.084l-.09-.084-3.723-3.724a.376.376 0 00-.468-.05A8.31 8.31 0 0124.901 24.91zm5.894.593a5.295 5.295 0 100 10.59 5.295 5.295 0 000-10.59z"
  }));
};

var _default = SvgIconVisibility;
exports.default = _default;